import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';

export const appHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const modifiedReq = req.clone({
    headers: req.headers.set('x-app', environment.site),
  });

  return next(modifiedReq);
};
